import { DASHBOARD } from "./actionTypes"
import { call, cancel, fork, put, take } from "redux-saga/effects"
import { apiError } from "../actions"
import { dashboardData } from "./actions"
import { apiGetDashboard } from "../../helpers/backend_helper"


function* doGetDashboardData({payload: {periodStart, periodEnd, companiesId, type, querys}}) {
  try {
    const param = (querys ? querys : {})
    const response = yield call(apiGetDashboard, {
      periodStart,
      periodEnd,
      companiesId,
      type,
      ...param
    })
    yield put(dashboardData(response))
  } catch (error) {
    yield put(apiError(error))
  }
}

// Cada tipo ocupa uma única posição no estado (dashboardVendas, dashboardMaisVendidos...).
// Uma nova pesquisa do mesmo tipo cancela a anterior; senão a resposta mais lenta, de um
// filtro já trocado, chega por último e sobrescreve o resultado do filtro atual.
function* DashboardSaga() {
  const pesquisasPorTipo = {}
  while (true) {
    const action = yield take(DASHBOARD)
    const tipo = action.payload.type
    if (pesquisasPorTipo[tipo]) {
      yield cancel(pesquisasPorTipo[tipo])
    }
    pesquisasPorTipo[tipo] = yield fork(doGetDashboardData, action)
  }
}

export default DashboardSaga
